import { ParserRegistry } from './parserRegistry';

export function parseText(text: string): string {
  let result = '';
  let position = 0;

  while (position < text.length) {
    const readText = readUntilPipe(text.substring(position));
    result += readText;
    position += readText.length;

    if (position >= text.length) break;

    const tag = readUntilPipe(text.substring(++position));
    position += tag.length + 1;

    const parser = ParserRegistry.getParser(tag);
    const parseResult = parser?.parse(text.substring(position));
    if (!parseResult) {
      result += `|${tag}|`;
      continue;
    }

    result += parseResult.html;
    position += parseResult.consumedLength;
  }

  return result.replace(/\r\n|\r|\n/g, '<br>');
}

function readUntilPipe(text: string) {
  let tag = '';
  let position = 0;
  while (position < text.length && text[position] !== '|') {
    tag += text[position];
    position++;
  }
  return tag;
}
